import MomentsUploadForm from './MomentsUploadForm';

const CustomersUploadForm = props => {
  const {
    onClose,
    action,
    onSubmit,
    job
  } = props;

  let jobId = job.id;
  let isDefault = false;
  let hideJobSelect = true;
  let hideDefaultCheckbox = true;

  return <MomentsUploadForm {...{
    onClose,
    action,
    onSubmit,
    jobId,
    isDefault,
    hideJobSelect,
    hideDefaultCheckbox
  }} />;
}

export default CustomersUploadForm;
